<main>
  <div fxLayout="column" fxLayoutAlign="center center">
    <img src="assets/images/404.svg" alt="background" aria-hidden="true">
    <h1>{{ 'app.errors.e404' | translate }}</h1>
    <button  mat-stroked-button color="darkblue" class="filled no-border" [routerLink]="'/my'">{{ 'reusable.goHome' | translate }}</button>
  </div>
</main>
